<script setup lang="ts">
import GrooverPlusSubscribeCta from './Subscription/GrooverPlusSubscribeCta.vue'

import Cta from '~/components/dato/Cta.vue'
import DatoSectionContainer from '~/components/dato/DatoSectionContainer.vue'
import JoinWaitListButton from '~/components/dato/Subscription/JoinWaitListButton.vue'

import type { CtasSectionFragment } from '~/graphql/generated'

type Props = CtasSectionFragment

withDefaults(defineProps<Props>(), {
  ctas: () => [],
})

function getComponentFromCta({
  __typename,
}: CtasSectionFragment['ctas'][number]) {
  switch (__typename) {
    case 'JoinWaitListCtaRecord':
      return markRaw(JoinWaitListButton)
    case 'GrooverPlusSubscribeCtaRecord':
      return markRaw(GrooverPlusSubscribeCta)
    case 'CtaRecord':
    default:
      return markRaw(Cta)
  }
}
</script>

<template>
  <DatoSectionContainer>
    <div
      class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-gap-lg lg:tw-flex-none lg:tw-flex-row"
    >
      <component
        :is="getComponentFromCta(cta)"
        v-for="cta in ctas"
        :key="cta.id"
        v-bind="cta"
        class="tw-w-full tw-max-w-[500px]"
      />
    </div>
  </DatoSectionContainer>
</template>
